import { RefObject, useState } from "react";
import { SocialContent } from "../../../../Panel/Social/Panel";
import { Post, UnreadComment } from "../../../../Panel/Social/Panel/types";
import { User, UserForRanking } from "../../../types";

export function SocialCard({
    user,
    isUserFetchDone,
    scrollableContainerRef,
    targetUserId,
    posts,
    setPosts,
    minTime,
    setMinTime,
    checkFetchNecessary,
    socialCardRef,
}: {
    user?: User;
    isUserFetchDone: boolean;
    scrollableContainerRef: RefObject<HTMLDivElement>;
    targetUserId: number;
    posts: Post[];
    setPosts: (posts: Post[]) => void;
    minTime: string;
    setMinTime: (minTime: string) => void;
    checkFetchNecessary?: () => boolean;
    socialCardRef?: RefObject<HTMLDivElement>;
}) {
    const [postedUsers, setPostedUsers] = useState<UserForRanking[]>([]);
    const userId = user?.userId ?? 0;
    const [fixedUnreadComments, setFixedUnreadComments] = useState<
        UnreadComment[]
    >([]);

    return (
        <SocialContent
            originKey="OtherUserPanel"
            scrollableContainerRef={scrollableContainerRef}
            posts={posts}
            setPosts={setPosts}
            minTime={minTime}
            setMinTime={setMinTime}
            postedUsers={postedUsers}
            setPostedUsers={setPostedUsers}
            user={user}
            userId={userId}
            isUserFetchDone={isUserFetchDone}
            isPostInputHidden
            targetUserId={targetUserId}
            scrollableSpanToFetch={1000}
            hideLevelAndCountry
            hideButtonTitle
            initialShurikenSize={30}
            fixedUnreadComments={fixedUnreadComments}
            setFixedUnreadComments={setFixedUnreadComments}
            shouldNotReadComments
            checkFetchNecessary={checkFetchNecessary}
            socialCardRef={socialCardRef}
        />
    );
}
